// extracted by mini-css-extract-plugin
module.exports = {"app-main":"app-main-20857ef42c015557b1c32637d1abf413","app-main__view":"app-main__view-f085efa24983e5c85e7423ad58c295e1"};